/**
 * Home page for a shop whose owner has not built one yet (`store.home` has no
 * blocks). Rather than an empty page between the header and the footer, show
 * the shop's categories and newest products with the regular blocks. When
 * there are no products either, the page says the shop is being set up.
 *
 * Returns the blocks to render plus `empty: true` when there is nothing to show.
 */
export const DEFAULT_NEW_PRODUCTS = 8;

export function buildDefaultHome({ categories = [], products = [], t }) {
  const blocks = [];
  const withProducts = categories.filter((c) => c.productCount > 0);
  if (withProducts.length) {
    blocks.push({
      id: 'default-categories',
      type: 'categories',
      title: t('home.defaultCategoriesTitle'),
      categories: withProducts,
    });
  }
  if (products.length) {
    blocks.push({
      id: 'default-newest',
      type: 'productRail',
      title: t('home.defaultNewestTitle'),
      link: { label: t('home.defaultSeeAll'), href: '/kategori/semua' },
      products,
    });
  }
  return { blocks, empty: blocks.length === 0 };
}
